import { gsap } from "gsap";

export default function toggleMenu() {
  let isOpen = false;
  let tl = gsap.timeline();

  const changeToggle = () => {
    if (isOpen) {
      document.querySelector(".p-globalnav").classList.remove("is-open");
      document.querySelector("html").classList.remove("is-globalnavOpen");
      gsap.to(".p-globalnav", {
        opacity: 0,
        visibility: "hidden",
      });
      isOpen = false;
    } else {
      document.querySelector("html").classList.add("is-globalnavOpen");
      tl.to(".p-globalnav", {
        opacity: 1,
        visibility: "initial",
      }).add(function () {
        document.querySelector(".p-globalnav").classList.add("is-open");
      });
      isOpen = true;
    }
  };

  document.querySelector(".js-drawer").addEventListener("click", () => {
    changeToggle();
  });
  document.querySelector(".p-overlay").addEventListener("click", () => {
    changeToggle();
  });
}
